import { socialApiRequest, apiRequest } from './apiWrapper'
import { API_METHOD, API_END_POINT } from '../utils/constants'

export async function fetchShareApi(content_id, isUGC) {
  const accessToken = localStorage.getItem('access')
  if (isUGC) {
    const response = await socialApiRequest({
      method: API_METHOD.Get,
      url: `${API_END_POINT.share}/${content_id}`
    })
    return response?.data
  } else {
    const response = await apiRequest({
      method: API_METHOD.Get,
      url: `${API_END_POINT.templateShare}/${content_id}`,
      headers: {
        'x-api-token': accessToken
      },
      skipCache: true
    })
    return response?.data
  }

  // const response = await socialApiRequest({
  //     method: API_METHOD.Get,
  //     url: `${API_END_POINT.share}/${content_id}`
  //   })
  //   return response?.data
}

export async function fetchShareCount(content_id, isUGC) {
  const accessToken = localStorage.getItem('access')
  if (isUGC) {
    const response = await socialApiRequest({
      method: API_METHOD.Post,
      url: `${API_END_POINT.share}/${content_id}`
    })
    return response
  } else {
    const response = await apiRequest({
      method: API_METHOD.Post,
      url: `${API_END_POINT.templateShare}/${content_id}`,
      headers: {
        'x-api-token': accessToken
      },
      skipCache: true
    })
    return response
  }
 
}

